document.addEventListener('DOMContentLoaded', function (event) {
  showLogoByScroll();
  stickyHeader();
});

function showLogoByScroll() {
  document.addEventListener('scroll', function () {
    let positionY = window.pageYOffset;
    let headerButtonHome = document.querySelector('.Header-buttonsElement.home');
    if (positionY > 50) {
      headerButtonHome.classList.add('show');
    } else {
      headerButtonHome.classList.remove('show');
    }
  });
}

function stickyHeader() {
  let body = document.querySelector('body');
  let headerBottom = document.querySelector('.Header-containerSub');
  let headerBottomHeight = parseInt(headerBottom.getBoundingClientRect().height) + 35;
  document.addEventListener('scroll', function () {
    let positionY = window.pageYOffset;
    if (positionY > headerBottomHeight) {
      body.classList.add('fixed');
      headerBottom.classList.add('fixed');
    } else {
      body.classList.remove('fixed');
      headerBottom.classList.remove('fixed');
    }
  });
}
